import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';
import { LucideAngularModule } from 'lucide-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { PackLimitationsService } from 'src/app/shared/services/pack-limitations.service';
import { LimitedFeatures } from 'src/app/shared/models/pack.models';

export interface SidebarMenuItem {
  label: string;
  icon: string;
  route: string;
  badge?: number;
  isActive?: boolean;
  testId?: string;
  onClick?: () => void;
  isLocked?: boolean;
  /** Shows a warning dot on the icon — something is missing on the target page. */
  warning?: boolean;
  /** Translation key describing the warning, used as its accessible label. */
  warningLabel?: string;
}

@Component({
  selector: 'app-sidebar-item',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TooltipModule,
    RippleModule,
    LucideAngularModule,
    TranslocoModule,
  ],
  templateUrl: './sidebar-item.component.html',
})
export class SidebarItemComponent {
  @Input() item!: SidebarMenuItem;
  @Input() isCollapsed = false;
  packLimitationService = inject(PackLimitationsService);
  limitedFeatures = LimitedFeatures;
}
